export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_8678be25dae93aedcd59a18b